import PropTypes from 'prop-types'
import React from 'react'
import { getUserInfo } from '../../../../../selectors'
import { connect } from 'react-redux'
import { Name } from '../Name'
import { Surname } from '../Surname'
import config from 'SRC/config/config.yaml'

export class Container extends React.PureComponent {
  isBusinessUser = () => this.props.type !== config.userTypes.freeUserTypeSeo

  getName = () => {
    const name = config.registrationForm.labels.name[this.props.type]
    if (name) return name
    return 'Ime'
  }

  render () {
    const isBusinessUser = this.isBusinessUser()
    return (
      <div className={isBusinessUser ? 'form-ime-prezime' : 'form-ime'}>
        <Name isFullWidth={isBusinessUser} isBusinessUser={isBusinessUser} label={this.getName()} />
        {!isBusinessUser ? <Surname /> : null}
      </div>
    )
  }
}

Container.displayName = 'Title'

const mapStateToProps = state => {
  const result = {}
  const userInfo = getUserInfo(state)
  if (userInfo) {
    if (userInfo.name) {
      result.name = userInfo.name
    }
    if (userInfo.surname) {
      result.surname = userInfo.surname
    }
    if (userInfo.type && userInfo.type.seo) {
      result.type = userInfo.type.seo
    }
  }
  return result
}

Container.propTypes = {
  type: PropTypes.string.isRequired
}

export default connect(mapStateToProps)(Container)
